import type { ReactNode } from "react";

import { useConfirm } from "material-ui-confirm";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useDiscardChangesConfirm = (): ((description?: ReactNode) => Promise<boolean>) => {
	const confirm = useConfirm();
	const { t } = useTranslation("common");

	return useCallback(
		async (description?: ReactNode) => {
			const { confirmed } = await confirm({
				cancellationButtonProps: { variant: "outlined" },
				cancellationText: t("actions.cancel"),
				confirmationButtonProps: { color: "error", variant: "contained" },
				confirmationText: t("discardChanges.confirm"),
				description: description ?? t("discardChanges.description"),
				// MUI focus enforcement on this confirm fights the bottom sheet it opens over
				dialogProps: { disableEnforceFocus: true },
				title: t("discardChanges.title")
			});
			return confirmed;
		},
		[confirm, t]
	);
};

export default useDiscardChangesConfirm;
